import { createFileRoute, redirect } from '@tanstack/react-router';

import { canManageOrganizationInvitations } from '@/features/organizations/permissions';
import { requireOrganizationRoleRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/_app/invitations')({
    beforeLoad: () => {
        requireOrganizationRoleRoute(canManageOrganizationInvitations);
        throw redirect({ to: '/organizations', hash: 'invitations' as never });
    },
    component: InvitationsRedirectPage
});

function InvitationsRedirectPage() {
    return null;
}
